<template>
  <span class="tab-header-actions">
    <span class="tab-header-actions__btn"
          :class="{ 'tab-header-actions__btn--active': pinned }"
          v-b-tooltip.hover.bottom
          :title="pinned ? 'Desfijar pestaña' : 'Fijar pestaña'"
          :aria-label="pinned ? 'Desfijar pestaña' : 'Fijar pestaña'"
          @click="togglePin">
      <AppIcon name="push-pin" :fill="pinned"></AppIcon>
    </span>

    <span v-if="showShortcut"
          class="tab-header-actions__btn"
          :class="{ 'tab-header-actions__btn--active': isShortcut, 'tab-header-actions__btn--disabled': isShortcut }"
          v-b-tooltip.hover.bottom
          :title="isShortcut ? 'Ya agregado a Favoritos' : 'Agregar a Favoritos'"
          :aria-label="isShortcut ? 'Ya agregado a Favoritos' : 'Agregar a Favoritos'"
          @click="toggleShortcut">
      <AppIcon :name="isShortcut ? 'star-fill' : 'star'"></AppIcon>
    </span>
  </span>
</template>

<script>
import { EventBus } from '@/handler/event-bus'

export default {
  name: 'TabHeaderActions',
  props: {
    showShortcut: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pinned: false,
      isShortcut: false,
    }
  },
  created() {
    EventBus.$on('Tab:ActiveState', this.applyState)
    this.announce()
  },
  // Con <keep-alive>, volver a un dashboard ya visitado dispara activated()
  // en vez de created() — hay que re-anunciarse igual para que el tab bar
  // sepa que ESTE tab (el que ahora está activo) controla desde la cabecera.
  activated() {
    this.announce()
  },
  beforeDestroy() {
    EventBus.$off('Tab:ActiveState', this.applyState)
  },
  methods: {
    announce() {
      EventBus.$emit('Tab:ControlsInHeader', true)
      EventBus.$emit('Tab:RequestActiveState')
    },
    applyState(state) {
      this.pinned = !!(state && state.pinned)
      this.isShortcut = !!(state && state.isShortcut)
    },
    togglePin() {
      EventBus.$emit('Tab:RequestTogglePin')
    },
    toggleShortcut() {
      if (this.isShortcut) return
      EventBus.$emit('Tab:RequestToggleShortcut')
    },
  },
}
</script>

<style scoped>
.tab-header-actions {
  display: inline-flex;
  align-items: center;
}
.tab-header-actions__btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  margin-right: 2px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  color: var(--app-color-icon);
  /* Mismo font-size que .widget-config-link/.widget-lock-link (WidgetVisibilityConfig.vue)
     — ambos viven en la misma botonera de cabecera y el ícono debe verse del
     mismo tamaño en los dos. */
  font-size: 16px;
  cursor: pointer;
  transition: color 0.16s ease, background-color 0.16s ease;
}
.tab-header-actions__btn:last-child {
  margin-right: 0;
}
.tab-header-actions__btn:hover {
  color: var(--app-color-primary);
  background: var(--app-color-primary-soft);
}
.tab-header-actions__btn--active {
  color: var(--app-color-primary);
}
.tab-header-actions__btn--disabled {
  cursor: default;
}
@media (max-width: 767.98px) {
  .tab-header-actions__btn {
    width: 34px;
    height: 34px;
    font-size: 18px;
  }
}
</style>
